/* Workzone - centratura automatica del capo nelle card prodotto.
   Le foto Payper hanno composizioni diverse (capo in alto con tanto bianco sotto, capo piccolo, ecc.).
   Per ogni card si legge una miniatura della foto (stesso dominio del sito), si trova il riquadro
   occupato dal capo (pixel non bianchi) e lo si porta al CENTRO della card, ingrandendolo quanto basta
   perche' tutti i capi abbiano piu' o meno la stessa grandezza. Proporzioni mai deformate.
   Se qualcosa non funziona (foto non leggibile) la card resta semplicemente come prima. */
(function () {
  if (window.wzCardCenter) return; window.wzCardCenter = true;
  var FILL_W = 0.84, FILL_H = 0.80, MAX_S = 1.7, MIN_S = 0.85, THR = 236;

  function thumbUrl(src) {
    try { var u = new URL(src, location.href); u.searchParams.set('width', '96'); u.searchParams.delete('height'); return u.toString(); }
    catch (e) { return src; }
  }
  function bbox(im) {
    var w = im.naturalWidth, h = im.naturalHeight; if (!w || !h) return null;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(im, 0, 0);
    var d; try { d = x.getImageData(0, 0, w, h).data; } catch (e) { return null; }
    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var j = 0; j < h; j++) for (var i = 0; i < w; i++) {
      var k = (j * w + i) * 4;
      if (d[k + 3] > 20 && (d[k] < THR || d[k + 1] < THR || d[k + 2] < THR)) {
        if (i < x0) x0 = i; if (i > x1) x1 = i; if (j < y0) y0 = j; if (j > y1) y1 = j;
      }
    }
    if (x1 < 0) return null;
    return { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h, r: w / h };
  }
  function apply(img) {
    var b = img._wzBox; if (!b) return;
    var W = img.clientWidth, H = img.clientHeight; if (!W || !H) return;
    var r = b.r, dW, dH, oX, oY;
    if (W / H > r) { dH = H; dW = H * r; oX = (W - dW) / 2; oY = 0; } else { dW = W; dH = W / r; oX = 0; oY = (H - dH) / 2; }
    var gx0 = oX + b.x0 * dW, gx1 = oX + b.x1 * dW, gy0 = oY + b.y0 * dH, gy1 = oY + b.y1 * dH;
    var gw = gx1 - gx0, gh = gy1 - gy0, cx = (gx0 + gx1) / 2, cy = (gy0 + gy1) / 2;
    if (gw < 4 || gh < 4) return;
    var s = Math.min(FILL_W * W / gw, FILL_H * H / gh); s = Math.max(MIN_S, Math.min(MAX_S, s));
    img.style.transformOrigin = cx + 'px ' + cy + 'px';
    img.style.transform = 'translate(' + (W / 2 - cx).toFixed(1) + 'px,' + (H / 2 - cy).toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
  }
  function prep(img) {
    if (img._wzDone) return; img._wzDone = true;
    var src = img.currentSrc || img.src; if (!src) return;
    var t = new Image(); t.crossOrigin = 'anonymous';
    t.onload = function () { var b = bbox(t); if (b) { img._wzBox = b; apply(img); img.classList.add('wz-centered'); } };
    t.src = thumbUrl(src);
  }
  function scan() { document.querySelectorAll('.product-card-wrapper .card__media img').forEach(prep); }
  function reapply() { document.querySelectorAll('.product-card-wrapper .card__media img').forEach(apply); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  window.addEventListener('load', scan);
  window.addEventListener('resize', function () { clearTimeout(window._wzCC); window._wzCC = setTimeout(reapply, 150); });
  if (window.MutationObserver) new MutationObserver(function () { clearTimeout(window._wzCM); window._wzCM = setTimeout(scan, 100); }).observe(document.body, { childList: true, subtree: true });
})();
